<template>
  <div class="schoolWorks-detail">
    <img v-if="activityObj!=null" :src="activityObj.image" class="competition-img">
    <div class="competition-content">
      <div class="info content">
        <div class="info-fun">
          <div class="info-left">
            <h3><strong>作品详情</strong></h3>
            <div class="title"><strong>{{worksDetail.name}}</strong></div>
            <div class="plate">
              <span v-if="worksDetail.categoryName" :style="'background:'+worksDetail.categoryColor">{{worksDetail.categoryName}}</span>
              <span v-if="worksDetail.plateName" :style="'background:'+worksDetail.plateColor">{{worksDetail.plateName}}</span>
            </div>
            <div v-if="worksDetail.schoolName">机构信息：<span>{{ worksDetail.schoolName }}</span></div>
            <div v-if="worksDetail.mentor">指导老师：<span>{{ worksDetail.mentor }}</span></div>
            <div v-if="worksDetail.realName">作者姓名：<span>{{ worksDetail.realName }}</span></div>
            <div v-if="worksDetail.material">材料：<span>{{ worksDetail.material }}</span></div>
            <div v-if="worksDetail.weight">重量：<span>{{ worksDetail.weight }}</span></div>
            <div v-if="worksDetail.worksSize">尺寸：<span>{{ worksDetail.worksSize }}</span></div>
          </div>
          <div class="info-right">
            <div class="num" v-if="0"><em>{{ worksDetail.votesToker }}</em>票</div>
            <div class="submit" @click="submitVote" v-if="0">我要投票</div>
          </div>
        </div>
        <hr style="color:#f3f3f3">
        <div>
          作品介绍：
          {{worksDetail.content}}
        </div>
      </div>

      <div class="video content" v-if="worksDetail.video!=null">
        <video controls style="width: 100%;margin: 0 auto;max-height: 800px;padding:10px">
          <source :src="worksDetail.video" type="video/mp4">
          您的浏览器不支持视频播放
        </video>
      </div>
      <div class="pic-list content" v-if="worksDetail.imageArr!=null &&worksDetail.imageArr.length>0">
        <img :src="img" v-for="(img,index) of worksDetail.imageArr" :key="index">
      </div>
    </div>
  </div>
</template>

<script>
import {bannerAreaList, artCourseList} from "@/api/CourseCenter";
import {getArtCategoryList} from "@/api/Home.js";
import {getWorksDetail,activityDetail} from "@/api/Vote";
import {mapGetters} from "vuex";

export default {
  name: "workCompetition",
  components: {
    // Tabs,
  },
  data() {
    return {
      id: 0,
      activityObj:{},
      bannerList: [],
      chapterId: 0,
      playAuth: "",
      worksDetail: {},
    };
  },
  computed: mapGetters(["userInfo", "isLogin"]),
  mounted() {
    this.id = this.$route.query.id;
    this.getWorksInfo();
  },
  methods: {
    getUid() {
      return (this.userInfo && this.userInfo.uid) | 0;
    },
    submitVote(){
      this.$message.error("电脑端投票正在研发中……")
    },
    onChange() {
    },
    getWorksInfo() {
      if (!this.id) {
        this.$message.error("作品ID不存在");
        return;
      }
      bannerAreaList({area: 1, num: 1})
          .then((res) => {
            this.bannerList = res.data;
          })
          .catch((err) => {
            this.$message.error(err.message || "轮播图加载失败");
          });
      getWorksDetail(this.id,{uid:this.getUid()}).then(res=>{

        if(res.status==200){
          this.worksDetail=res.data
          this.getActivity(res.data.activityId)
        }
      })

    },
    getActivity(activityId) {
      activityDetail(activityId, {isShow: 0, uid: this.getUid()}).then(res => {
        this.activityObj = res.data
      })
    },
  },
};
</script>
<style lang="scss">
.schoolWorks-detail {
  background: #f7f8fa;

  .competition-img {
    width: 100%;
    height: 250px;
  }

  .competition-content {
    margin: 10px auto;
    width: 1280px;
    text-align: left;

    .content {
      background: #ffffff;
      border-radius: 10px;
      box-shadow: 0px 0px 8px 5px rgb(0 0 0 / 9%);
      margin: 30px auto;
      padding: 20px;
    }

    .info {
      color: #666666;
      line-height: 30px;
      .info-fun{
        display: flex;
        justify-content: space-between;
        .info-left {
          width: 1000px;

          h3 {
            height: 30px;
            line-height: 30px;
            font-size: 18px;
            color: #000;
            margin-left: -10px;
            position: relative;
            text-indent: 12px;
            &::before {
              content: "";
              position: absolute;
              left: -0px;
              top: 8px;
              width: 3px;
              height: 14px;
              background-color: #E28947;
            }
          }
          .title{
            color: #000;
            font-size: 20px;
            margin: 20px 0 10px 0;
          }
          .plate{
            color: #000;
             span{
               font-size: 12px;
               color: #ffffff;
               margin-right: 10px;
               padding:1px 10px 2px 10px;
               border-radius: 3px;
             }
          }
          span {
            color: #999999;
          }
          div{
            height: 25px;
            line-height: 25px;
          }
        }
        .info-right {
          margin-top: 100px;
          text-align: center;
          .num {
            color: #E28947;
            font-size: 16px;
            em {
              margin-top: 8px;
              margin-right: 5px;
              font-size: 26px;
            }
          }
          .submit {
            margin-top: 10px;
            border-radius: 50px;
            padding: 0px 30px;
            background: #E28947;
            color: #ffffff;
            font-size: 16px;
          }
        }
      }
    }

    .video {

    }

    .pic-list {
      img {
        width: 100%;
        height: auto;
      }
    }
  }
}
</style>
